export const ValueTypes = {
  ANY: 'any',
  FIXED: 'fixed',
  SUGGESTIONS: 'suggestions',
  CHOOSE: 'choose',
  EMPTY: 'empty',
  APP_WIDE_DEFAULT: 'default',
} as const;
